module.exports = __webpack_public_path__ + "img/main_sell.4a876f05.jpg";